module.exports = __webpack_public_path__ + "e5b3ff6a0b7b0bf33636b4ccd58c1234.png";